__turbopack_context__.v({
  "react-international-phone-country-selector-button": "phone-input-module__NDQFra__react-international-phone-country-selector-button",
  "react-international-phone-input": "phone-input-module__NDQFra__react-international-phone-input",
  "react-international-phone-input--disabled": "phone-input-module__NDQFra__react-international-phone-input--disabled",
  "react-international-phone-input-container": "phone-input-module__NDQFra__react-international-phone-input-container",
});
